var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorPalette(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m428.403 152.544c-15.193-13.268-32.429-24.613-51.234-33.608l-12.256 8.88 29.36 117.183 11.54 3.063c42.613-11.252 56.48-65.923 22.59-95.518z",
    fill: "#dbedff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.539 359.48c-7.34-8.357-16.714-15.457-28.166-20.599-22.603-10.149-36.508-23.614-36.508-38.526 0-16.035 16.047-30.351 41.623-40.696l11.68-11.597-42.566-140.162-21.456-15.796-15.01 4.748c-134.384-13.814-250.604 81.817-250.604 203.503 0 143.905 159.152 242.89 306.257 191.092 29.852-10.511 47.683-34.498 53.021-60.853l8.669-7.46-10.989-60.094z",
    fill: "#dbedff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.029 300.355c0-108.755 92.836-196.687 208.501-204.288l-5.384-3.964-15.01 4.748c-134.384-13.813-250.604 81.818-250.604 203.504 0 127.698 125.324 220.008 256.343 202.99-105.713-13.717-193.846-95.906-193.846-202.99z",
    fill: "#b5dcff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.219,
    cy: 206.598,
    fill: "#f87c68",
    r: 33.643
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255.303,
    cy: 164.304,
    fill: "#ffd064",
    r: 32.638
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.827,
    cy: 403.618,
    fill: "#5291d9",
    r: 32.638
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275.88,
    cy: 434.119,
    fill: "#95d6a4",
    r: 32.638
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.893,
    cy: 308.456,
    fill: "#ff94d5",
    r: 39.379
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.065 206.598c0-12.482 6.803-23.369 16.899-29.176-4.932-2.837-10.646-4.468-16.745-4.468-18.581 0-33.643 15.063-33.643 33.643s15.063 33.643 33.643 33.643c6.098 0 11.812-1.631 16.745-4.468-10.096-5.805-16.899-16.692-16.899-29.174z",
    fill: "#ec625e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.154 164.304c0-11.903 6.374-22.315 15.893-28.016-4.896-2.933-10.622-4.622-16.744-4.622-18.026 0-32.638 14.613-32.638 32.638s14.612 32.638 32.638 32.638c6.122 0 11.849-1.689 16.744-4.622-9.518-5.702-15.893-16.113-15.893-28.016z",
    fill: "#ffc250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.678 403.618c0-11.903 6.374-22.315 15.894-28.016-4.896-2.933-10.622-4.622-16.745-4.622-18.025 0-32.638 14.613-32.638 32.638 0 18.026 14.613 32.638 32.638 32.638 6.122 0 11.849-1.689 16.745-4.622-9.52-5.702-15.894-16.113-15.894-28.016z",
    fill: "#2e82d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.731 434.119c0-11.903 6.374-22.315 15.894-28.016-4.896-2.933-10.622-4.622-16.744-4.622-18.026 0-32.638 14.613-32.638 32.638s14.612 32.638 32.638 32.638c6.122 0 11.849-1.689 16.744-4.622-9.52-5.702-15.894-16.113-15.894-28.016z",
    fill: "#78c2a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.003 308.456c0-15.759 9.261-29.35 22.634-35.644-5.082-2.392-10.756-3.735-16.744-3.735-21.748 0-39.379 17.63-39.379 39.379s17.63 39.379 39.379 39.379c5.989 0 11.662-1.343 16.744-3.735-13.373-6.294-22.634-19.885-22.634-35.644z",
    fill: "#ff72c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m380.771 53.284c-7.587-27.904-33.392-27.557-57.004-51.056-4.106-4.086-10.668-2.302-12.14 3.301-8.463 32.219-30.892 44.987-23.305 72.89 6.106 22.457 26.113 32.453 37.299 36.383l6.326 5.158 32.966-7.726 2.116-8.69c7.656-9.053 19.848-27.803 13.742-50.26z",
    fill: "#e39b74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m355.931 111.026c-11.186-3.931-31.193-13.927-37.299-36.383-6.567-24.153 9.35-36.975 19.238-60.878-4.682-3.184-9.435-6.89-14.103-11.535-4.106-4.086-10.668-2.302-12.14 3.301-8.463 32.219-30.892 44.987-23.305 72.89 6.106 22.457 26.113 32.453 37.299 36.383l6.326 5.158 27.141-6.361z",
    fill: "#dd8858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.997 110.948c-1.494-5.494-7.159-8.738-12.653-7.244l-32.601 8.864c-5.494 1.494-8.738 7.159-7.244 12.654l16.607 61.081 5.977 4.354 44.641-10.645 1.881-7.983z",
    fill: "#477b9e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367.137 180.611-17.717-65.164c-.82-3.015-.295-6.073 1.198-8.554l-20.875 5.676c-5.494 1.494-8.738 7.159-7.244 12.654l16.607 61.081 5.977 4.354 27.005-6.44z",
    fill: "#3f6d8e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m464.32 485.727c-.357-34.657-5.747-69.078-16.003-102.184l-56.236-179.254-7.337-5.133-27.875 6.31-1.841 8.897 42.27 183.051c7.919 33.742 20.699 66.154 37.94 96.22l7.119 12.415c2.68 4.674 8.178 6.949 13.377 5.535s8.788-6.159 8.733-11.547z",
    fill: "#ffd064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m459.473 483.332c-17.241-30.066-30.021-62.478-37.94-96.22l-42.27-183.051.795-3.845-23.189 5.249-1.841 8.897 42.27 183.051c7.919 33.742 20.699 66.154 37.94 96.22l7.119 12.415c2.68 4.674 8.178 6.949 13.377 5.535s8.788-6.159 8.733-11.547l-.084-8.141z",
    fill: "#ffc250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390.063 172.297-49.493 13.456c-4.671 1.27-7.427 6.085-6.157 10.756l3.64 13.389c1.27 4.67 6.085 7.427 10.756 6.157l49.493-13.456c4.67-1.27 7.427-6.085 6.157-10.755l-3.64-13.389c-1.27-4.672-6.086-7.428-10.756-6.158z",
    fill: "#5895b7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.13 201.652-3.887-14.296c-.895-3.29.091-6.641 2.292-8.935l-26.965 7.331c-4.671 1.27-7.427 6.085-6.157 10.756l3.64 13.389c1.27 4.67 6.085 7.427 10.755 6.157l27.973-7.605c-3.56-.532-6.646-3.101-7.651-6.797z",
    fill: "#477b9e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPalette);
export default __webpack_public_path__ + "static/media/color-palette.17ae7d695bfe866d78849e670fd96dc6.svg";
export { ForwardRef as ReactComponent };